import { gql } from "@apollo/client";export default gql`mutation DeleteGroupTagMap($ids: [Int!]) {
  delete_group_tag_map(where: {id: {_in: $ids}}) {
    affected_rows
  }
}
`;
